<div
    class="agpr-themeAnalyticsTrends"
>
    <!-- Top posts -->
    <div
        class="agpr-themeAnalyticsTrends-topTerms"
        [id]="id + '.trends' + '.topPostsSeries'"
    >
        <agpr-top-posts
            *ngIf="topPostsSeries"
            [id]="id + '.trends' + '.topPosts'"
            [series]="topPostsSeries"
            [availableNetworkTypes]="enabledNetworkTypes"
            [enableEngagementInsights]="!isArchiveSearch || (isArchiveSearch && enableEngagementInsights)"
        >
        </agpr-top-posts>
    </div>

    <!-- Most Used Top Terms -->
    <div
        class="agpr-themeAnalyticsTrends-topTerms"
        [id]="id + '.trends' + '.mostUsedTopTermsSeries'"
    >
        <agpr-top-terms
            *ngIf="mostUsedTopTermsSeries"
            [id]="id + '.trends' + '.topterms.mostUsed'"
            [series]="mostUsedTopTermsSeries"
            [initialMetric]="mentionSearchFacetTypesEnum.hashtags"
            [config]="mostUsedTopTermsConfig"
            [availableNetworkTypes]="enabledNetworkTypes"
        ></agpr-top-terms>
    </div>

    <!-- Most Prominent Top Terms -->
    <div
        class="agpr-themeAnalyticsTrends-topTerms"
        [id]="id + '.trends' + '.mostProminentTopTermsSeries'"
    >
        <agpr-top-terms
            *ngIf="mostProminentTopTermsSeries"
            [id]="id + '.trends' + '.topterms.mostProminent'"
            class="agpr-themeAnalyticsTrends-topTerms"
            [series]="mostProminentTopTermsSeries"
            [initialMetric]="mentionSearchFacetTypesEnum.hashtags"
            [config]="mostProminentTopTermsConfig"
            [wordCloudSortField]="searchCriteriaSortFieldEnum.audience_reach"
            [availableNetworkTypes]="enabledNetworkTypes"
            [analysisType]="socialMetricAnalysisTypes.impressions"
            [hideWords]="true"
        ></agpr-top-terms>
    </div>
</div>
